import React, { useRef, useState, useEffect } from "react";
import { formatMoneda } from "../../../util/varios";
import { Radio } from "../../../ui/inputs/Input";
import axios from "axios";

import { Dimmer } from "../../spinner";
import { TableBody, TableRow, TableCell, InputAdornment } from "@mui/material";
import useTableFijo from "../../useTableFijo";

const TablaDeudasEjidos = (props) => {
  let token = localStorage.getItem("jwtToken");

  let op = require("../../../../src/modulos/datos");
  const fechaSistema = JSON.parse(localStorage.getItem("fechasistema"));
  const espiritu = JSON.parse(localStorage.getItem("espiritu"));
  const [activate, setActivate] = useState(false);
  const anioactu = JSON.parse(localStorage.getItem("anioactu"));

  const [titulo, setTitulo] = useState();
  const [msg, setMsg] = useState();
  const [mostrar, setMostrar] = useState(false);
  const [mostrar3, setMostrar3] = useState(false);
  const [mostrar4, setMostrar4] = useState(false);
  const [deuda, setDeuda] = useState();
  const [interes, setInteres] = useState();
  const [recargo, setRecargo] = useState();
  const [multa, setMulta] = useState();
  const [totDeuda, setTotDeuda] = useState();
  const txtBolivares = useRef();
  const txtPetro = useRef();
  const [monto, setMonto] = useState(props.petro);
  const [parametro, setParametro] = useState("1");
  const [visibleF, setVisibleF] = useState("hidden");
  const [credito, setCredito] = useState(0.0);

  // 1 = Monto en Bs. / 0 = Monto en U.C
  const [moneda, setMoneda] = useState(1);

  const [records, setRecords] = useState([]);

  // 👇 NUEVO: factor de cambio protegido (evita dividir entre 0 o undefined)
  const factorCambio = JSON.parse(localStorage.getItem("factorCambio"));
  const factorValor = factorCambio?.valor
  // 👇 NUEVO: convierte strings "1234,56" o números a float de forma segura
  const aNumero = (valor) =>
    parseFloat(String(valor ?? 0).replace(",", ".")) || 0;

  // 👇 NUEVO: ¿está marcado el radio "Monto en U.C"? (value = 0)
  const esUc = Number(moneda) === 0;

  // 👇 NUEVO: convierte un monto según el radio seleccionado
  // U.C -> divide entre el factor de cambio | Bs -> valor normal
  const convertir = (valor) => {
    const num = aNumero(valor);
    return esUc ? num / factorValor : num;
  };

  // 👇 NUEVO: convierte y formatea con 2 decimales
  const fmt = (valor) =>
    formatMoneda(convertir(valor).toFixed(2).replace(".", ","), ",", ".", 2);

  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const headCells = [
    // ... (exactamente igual que lo tienes)
    {
      id: "anio",
      label: "AÑO",
      width: "10px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
      disableSorting: true,
    },
    {
      id: "mes",
      label: "MES",
      width: "80px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
      disableSorting: true,
    },
    {
      id: "mondeu",
      label: "MONTO",
      width: "150px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
      disableSorting: true,
    },
    {
      id: "intmoradeu",
      label: "INTERES MORA",
      width: "150px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
      disableSorting: true,
    },
    {
      id: "recargodeu",
      label: "RECARGOS",
      width: "150px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
      disableSorting: true,
    },
  ];

  let heightTabla = 320;

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTableFijo(records, headCells, filterFn, heightTabla);

  // 👇 NUEVO: reemplaza a "calculo". Suma los valores CRUDOS (sin convertir)
  // y al final aplica la conversión según el radio Bs / U.C
  const calcularTotales = (lista) => {
    let deu = 0;
    let inte = 0;
    let reca = 0;
    let mul = 0;

    (lista || []).forEach((item) => {
      deu += aNumero(item.monto);
      inte += aNumero(item.intereses);
      reca += aNumero(item.recargo);
      mul += aNumero(item.multa);
    });

    setDeuda(fmt(deu));
    setInteres(fmt(inte));
    setRecargo(fmt(reca));
    setMulta(fmt(mul));
    // Si el total NO debe incluir la multa, usa: fmt(deu + inte + reca)
    setTotDeuda(fmt(deu + inte + reca + mul));
  };

  const tasa = () => {
    if (txtBolivares.current.checked) {
      setParametro("1");
    } else if (txtPetro.current.checked) {
      setParametro("2");
    }
  };

  useEffect(() => {
    if (props.tabdeuda) {
      setRecords(props.tabdeuda); // 👈 CAMBIADO: antes lo hacía "calculo"
    }
    setCredito(props.credito);
    setVisibleF(props.visibleF);
  }, [props.tabdeuda]);

  // 👇 NUEVO: los totales se recalculan solos cuando cambian los datos
  // O cuando se cambia el radio entre Bs y U.C
  useEffect(() => {
    calcularTotales(records);
  }, [records, moneda]);

  const imprimirDeuda = (reporte) => (event) => {
    event.preventDefault();
    var idrentas = props.idrentas;
    reporte = "EdoCtaCorto2RentaInmob";
    window.open(
      op.reportes +
        "/rentasinmobiliarias?" +
        "reporte=" +
        reporte +
        "&id=" +
        idrentas +
        "&valor=" +
        factorValor +
        "&tipo=" +
        moneda,
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
    );
  };

  // const SelectDeudaC = (idrentas, fechaSistema, espiritu, value) => {
  //   setActivate(true);
  //   let tabla = "aseo";
  //   let endpoint = "";
  //   if (espiritu === 0) {
  //     endpoint = `${op.conexion}/api/aseo/deudarenta?idrentas=${idrentas}&fecha=${fechaSistema}&tabla=${tabla}&unidad=${value}`;
  //   } else {
  //     endpoint = `${op.conexion}/api/aseo/deudarenta1?idrentas=${idrentas}&fecha=${fechaSistema}&tabla=${tabla}&unidad=${value}`;
  //   }
  //   axios
  //     .get(endpoint, {
  //       headers: {
  //         "x-access-token": `${token}`,
  //         "Content-Type": "application/json",
  //       },
  //     })
  //     .then(function (response) {
  //       if (response.status == 200) {
  //         var deu = [];
  //         var his = [];
  //         var mesactu = (new Date(fechaSistema).getMonth() + 1)
  //           .toString()
  //           .padStart(2, 0);
  //         for (let i = 0; i < response.data.length; i++) {
  //           if (response.data[i].fechapago === null) {
  //             if (parseInt(response.data[i].anio) < parseInt(anioactu)) {
  //               deu.push({
  //                 anio: response.data[i].anio,
  //                 mes: response.data[i].mes.replace("'", "").replace("'", ""),
  //                 monto: response.data[i].mondeu,
  //                 intereses: response.data[i].intmoradeu * props.factorCambio,
  //                 multa: response.data[i].multa * props.factorCambio,
  //                 recargo: response.data[i].recargodeu * props.factorCambio,
  //               });
  //             } else if (
  //               parseInt(response.data[i].anio) === parseInt(anioactu) &&
  //               parseInt(response.data[i].nmes) < parseInt(mesactu)
  //             ) {
  //               deu.push({
  //                 anio: response.data[i].anio,
  //                 mes: response.data[i].mes.replace("'", "").replace("'", ""),
  //                 monto: response.data[i].mondeu,
  //                 intereses: response.data[i].intmoradeu * props.factorCambio,
  //                 multa: response.data[i].multa * props.factorCambio,
  //                 recargo: response.data[i].recargodeu * props.factorCambio,
  //               });
  //             }
  //           } else {
  //             his.push({
  //               anio: response.data[i].anio,
  //               mes: response.data[i].mes.replace("'", "").replace("'", ""),
  //               monto: response.data[i].mondeu,
  //               intereses: response.data[i].intmoradeu,
  //               recargo: response.data[i].recargodeu,
  //               multa: response.data[i].multa,
  //               descuento: response.data[i].mondescue,
  //               recibo: response.data[i].numreci,
  //               fechapago: response.data[i].fechapago,
  //             });
  //           }
  //         }
  //         setRecords(deu); // 👈 el useEffect de arriba recalcula los totales solo
  //       }
  //     })
  //     .catch(function (error) {
  //       console.log(error);
  //     })
  //     .finally(() => setActivate(false));
  // };

  const renderDeuda = (e) => {
    const { value } = e.target;
    setMoneda(value); // 👈 con esto solo, la tabla y los totales ya se convierten
    //   SelectDeudaC(props.idrentas, fechaSistema, espiritu, value);
  };

  return (
    <div className="card-body">
      <div
        className="row col-md-12 d-flex justify-content-between mx-auto"
        style={{ height: "100%" }}
      >
        <div className="col-md-12 d-flex justify-content-between mb-2">
          <div className="col-auto m-0 p-0 d-flex gap-2 align-items-start">
            <div class="col-auto m-0 p-0">
              <Radio
                label="Monto en Bs."
                onChange={renderDeuda}
                value={1}
                name="monto"
                id="montoBs"
                defaultChecked
              />
            </div>
            <div class="col-auto m-0 p-0">
              <Radio
                label="Monto en U.C"
                onChange={renderDeuda}
                value={0}
                name="monto"
                id="montUc"
              />
            </div>
          </div>
          <button
            style={{ height: "30px" }}
            onClick={imprimirDeuda("EdoCtaCorto2RentaInmob")}
            className="btn btn-sm btn-primary rounded-circle"
          >
            <i className="fas fa-print"></i>{" "}
          </button>
        </div>
        <div className="col-md-12 mx-auto px-0">
          <TblContainer
            container={{
              height: 250,
              width: "100%",
              overflow: "auto",
              padding: "2px",
            }}
          >
            <TblHead />

            <tbody>
              {records &&
                records.map((item, index) => (
                  <tr key={item.anio + item.mes} style={{ padding: "0" }}>
                    <td style={{ fontSize: "10px", textAlign: "center" }}>
                      {item.anio}
                    </td>
                    <td style={{ fontSize: "10px", textAlign: "center" }}>
                      {item.mes}
                    </td>
                    <td style={{ fontSize: "10px", textAlign: "center" }}>
                      {fmt(item.monto)} {/* 👈 CAMBIADO */}
                    </td>
                    <td style={{ fontSize: "10px", textAlign: "center" }}>
                      {fmt(item.intereses)} {/* 👈 CAMBIADO */}
                    </td>
                    <td style={{ fontSize: "10px", textAlign: "center" }}>
                      {fmt(item.recargo)} {/* 👈 CAMBIADO */}
                    </td>
                  </tr>
                ))}
            </tbody>
          </TblContainer>
          <div
            className="col-md-12 border-table mx-auto row px-0"
            style={{ borderTop: "none" }}
          >
            <div className="col-md-8 row mx-auto">
              <div className="row col-md-8 mx-auto my-auto">
                <div className="col">
                  <label
                    htmlFor="inputRitm"
                    style={{ fontSize: "16px", fontWeight: "bold" }}
                  >
                    Crédito a Favor:{" "}
                  </label>
                </div>
                <div className="col">
                  <label
                    htmlFor="inputRitm"
                    style={{
                      fontSize: "16px",
                      textAlign: "right",
                      fontWeight: "bold",
                    }}
                  >
                    {fmt(credito)} {/* 👈 CAMBIADO: también se convierte */}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-md-4 row">
              <div class="input-group input-group-sm mb-0 col-md-12">
                <span
                  class="input-group-text bg-transparent border-0"
                  id="inputGroup-sizing-sm"
                >
                  Deuda:
                </span>
                <input
                  type="text"
                  value={deuda}
                  class="form-control text-right bg-transparent border-0"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                />
              </div>

              <div class="input-group input-group-sm mb-0 col-md-12">
                <span
                  class="input-group-text bg-transparent border-0"
                  id="inputGroup-sizing-sm"
                >
                  Intereses de Mora:
                </span>
                <input
                  type="text"
                  value={interes}
                  class="form-control text-right bg-transparent border-0"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                />
              </div>

              <div class="input-group input-group-sm mb-0 col-md-12">
                <span
                  class="input-group-text bg-transparent border-0"
                  id="inputGroup-sizing-sm"
                >
                  Recargo por Mora:
                </span>
                <input
                  type="text"
                  value={recargo}
                  class="form-control text-right bg-transparent border-0"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                />
              </div>

              <div class="input-group input-group-sm mb-0 col-md-12">
                <span
                  class="input-group-text bg-transparent border-0"
                  id="inputGroup-sizing-sm"
                >
                  Multa:
                </span>
                <input
                  type="text"
                  value={multa}
                  class="form-control text-right bg-transparent border-0"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                />
              </div>

              <div class="input-group input-group-sm mb-0 col-md-12">
                <span
                  class="input-group-text bg-transparent border-0"
                  id="inputGroup-sizing-sm"
                >
                  Total de la Deuda:
                </span>
                <input
                  type="text"
                  value={totDeuda}
                  class="form-control text-right bg-transparent border-0"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Dimmer active={activate} inverted></Dimmer>
    </div>
  );
};

export default TablaDeudasEjidos;
